import { Instance, SnapshotOut, types, flow, getRoot } from "mobx-state-tree"
import { RootStoreModel } from "~models/root-store"
import { withEnvironment } from "../extensions/with-environment"
// import { OrderModel } from "~models/order"
import { Event, EventNames, ExchangeOrderData, FLAG_REPLY, TransferData } from "~proto"

/**
 * 錢包資訊 store
 */

export const WalletStoreModel = types
  .model("WalletStore")
  .props({
    id: types.maybeNull(types.number),
    username: types.maybeNull(types.string),
    register_ip: types.maybeNull(types.string),
    real_name: types.maybeNull(types.string),
    avatar: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    phone: types.maybeNull(types.string),
    balance: types.maybeNull(types.string),
    isEncryptedBalance: types.maybeNull(types.boolean),
    wp_confirmed: types.maybeNull(types.boolean), // 支付密码是否设置
    friend_verify: types.maybeNull(types.boolean), // 好友验证
    is_2fa_enabled: types.maybeNull(types.boolean), // 是否开启谷歌验证
    device_verify_enabled: types.maybeNull(types.boolean), // 登录设备验证开关 True开启 False关闭
    new_device_notify_enabled: types.maybeNull(types.boolean), // 新设备通知开关 True开启 False关闭
    show_online_status: types.maybeNull(types.boolean), // 是否显示在线状态 True显示 False不显示
    online_display_rule: types.maybeNull(types.number), // 上线时间展示规则（1=始终显示实时状态，2=仅显示最近活跃时间）
    dnd_enabled: types.maybeNull(types.boolean), // 是否开启免打扰 True开启 False关闭
    dnd_time_slot: types.maybeNull(types.number), // 免打扰时间 slot
    msg_destruct_enabled: types.maybeNull(types.boolean), // 消息定时自毁开关 True开启 False关闭
    msg_destruct_option: types.maybeNull(types.number), // 1|2|3|4|5|6 — 自毁时间预设
    msg_notify_enabled: types.maybeNull(types.boolean), // 消息通知开关 True开启 False关闭
    msg_preview_enabled: types.maybeNull(types.boolean), // 消息预览开关 True开启 False关闭
    group_notify_enabled: types.maybeNull(types.boolean), // 群聊通知开关 True开启 False关闭
    channel_notify_enabled: types.maybeNull(types.boolean), // 频道通知开关 True开启 False关闭
    sound_enabled: types.maybeNull(types.boolean), // 声音通知开关 True开启 False关闭
    vibrate_enabled: types.maybeNull(types.boolean), // 震动通知开关 True开启 False关闭
  })
  .volatile<{
    exchangeOrderData: ExchangeOrderData | false
    isExchangeAlertShowing: boolean
    /** 本次登录会话内是否已通过支付密码校验（发红包首屏用） */
    redPacketFormPayPwdVerifiedSession: boolean
  }>(() => ({
    exchangeOrderData: false,
    isExchangeAlertShowing: false,
    redPacketFormPayPwdVerifiedSession: false,
  }))
  .extend(withEnvironment)
  .views(() => ({
    get authenticated() {
      return ""
    },
  }))
  .actions((self) => {
    const { authStore, apiStore } = getRoot<Instance<typeof RootStoreModel>>(self)

    const setWalletInfo = (data) => {
      try {
        self.id = data.id
        self.name = data.name
        self.username = data.username
        self.register_ip = data.register_ip
        self.real_name = data.real_name
        self.avatar = data.avatar
        self.email = data.email
        self.phone = data.phone
        self.balance = data.account?.balance_cny || "0"
        self.wp_confirmed = data.wp_confirmed
        self.friend_verify = data.friend_verify
        self.is_2fa_enabled = data.is_2fa_enabled
        self.device_verify_enabled = data.device_verify_enabled
        self.new_device_notify_enabled = data.new_device_notify_enabled
        self.show_online_status = data.show_online_status
        self.online_display_rule = data.online_display_rule
        self.dnd_enabled = data.dnd_enabled
        self.dnd_time_slot = data.dnd_time_slot
        self.msg_notify_enabled = data.msg_notify_enabled
        self.msg_preview_enabled = data.msg_preview_enabled
        self.group_notify_enabled = data.group_notify_enabled
        self.channel_notify_enabled = data.channel_notify_enabled
        self.sound_enabled = data.sound_enabled
        self.vibrate_enabled = data.vibrate_enabled
      } catch (e) {
      }
      
    }
    const setUserName = (str) => {
      self.username = str
    }
    const setEncryptedBalance = (value: boolean) => {
      self.isEncryptedBalance = value
    }
    const getExchange = () => {
      return {}
    }
    const onWalletBalanceChanged = () => {
      getWalletInfo()
    }
    const clearExchangeAlert = () => {
      self.exchangeOrderData = false
      self.isExchangeAlertShowing = false
    }
    const onExchageOrcerSucceeded = (data: ExchangeOrderData) => {
      self.exchangeOrderData = data
      self.isExchangeAlertShowing = true
      // {"data": {"amount": "84.03", "cancelled_at": null, "created": 1701075426000, "ex_amount": "11.77", "ex_order_no": "E2311270857062284062442", "expired_at": 1701076326000, "order_status": 1, "rate": "7.14", "user_id": "261", "username": "tom123456"}, "name": 114, "publish": false}
    }

    /** 标记本次登录会话内已通过支付密码校验（发红包首屏用） */
    const markRedPacketFormPayPwdVerified = () => {
      self.redPacketFormPayPwdVerifiedSession = true
    }

    /** 重置本次登录会话内支付密码校验状态（发红包首屏用） */
    const resetRedPacketFormPayPwdSession = () => {
      self.redPacketFormPayPwdVerifiedSession = false
    }

    const loadPaymentList = flow(function* () {
      const token = authStore.getToken
      const res = yield apiStore.getPaymentList({ token })
      if (res.code === 200 && res.data != null) {
        return res.data
      } else {
        return []
      }
    })
    const getExchangeList = flow(function* () {
      const token = authStore.getToken
      const res = yield apiStore.getExchangeList({ token })

      if (res.data) {
        return res.data
      } else {
        return []
      }
    })

    const getWalletInfo = flow(function* () {
      const token = authStore.getToken
      const res = yield apiStore.getWalletInfo({ token })
      // console.log('getWalletInfo', res)
      if (res?.data) {
        setWalletInfo(res.data)
      }
    })

    const getMessageDestroySetting = flow(function* () {
      const token = authStore.getToken
      const res = yield apiStore.getMessageDestroySetting({ token })
      // console.log('getMessageDestroySetting', res)
      if (res?.data) {
        self.msg_destruct_enabled = res.data.enabled
        self.msg_destruct_option = res.data.option
      }
    })

    const getWalletLog = flow(function* (params) {
      const token = authStore.getToken
      const res = yield apiStore.getWalletLog({ token, params })
      return res
    })

    const getTakeOrders = flow(function* (params) {
      const token = authStore.getToken
      const res = yield apiStore.getTakeOrders({ token, params })
      return res
    })

    const getTakeOrdersSold = flow(function* (params) {
      const token = authStore.getToken
      const res = yield apiStore.getTakeOrdersSold({ token, params })
      return res
    })

    const getTakeOrdersDisputed = flow(function* (params) {
      const token = authStore.getToken
      const res = yield apiStore.getTakeOrdersDisputed({ token, params })
      return res
    })

    const publicTransferNew = flow(function* (data: TransferData, onData, onError) {
      const { eventStore } = getRoot<Instance<typeof RootStoreModel>>(self)
      const evt = new Event<TransferData>(EventNames.TRANSFER_NEW, data)
      eventStore.publish(evt, {
        flags: FLAG_REPLY,
        onData,
        onError,
      })
    })

    return {
      setUserName,
      setWalletInfo,
      loadPaymentList,
      getWalletInfo,
      getWalletLog,
      getTakeOrders,
      getTakeOrdersSold,
      getTakeOrdersDisputed,
      publicTransferNew,
      onWalletBalanceChanged,
      getExchangeList,
      getExchange,
      onExchageOrcerSucceeded,
      clearExchangeAlert,
      setEncryptedBalance,
      markRedPacketFormPayPwdVerified,
      resetRedPacketFormPayPwdSession,
      getMessageDestroySetting
    }
  })

type WalletStoreType = Instance<typeof WalletStoreModel>
export interface WalletStore extends WalletStoreType {}
type WalletStoreSnapshotType = SnapshotOut<typeof WalletStoreModel>
export interface WalletStoreSnapshot extends WalletStoreSnapshotType {}
export const createWalletStoreDefaultModel = () => types.optional(WalletStoreModel, {})
